import { EnumTokenVendors } from '@blank/api'
import { usePostGenerateVendorTokenMutation } from 'modules/auth/mutations/usePostGenerateVendorTokenMutation'
import { useAuthenticatedUserQuery } from 'modules/auth/queries/useAuthenticatedUserQuery'
import { useCountryConfig } from 'modules/common/hooks/useCountryConfig'
import {
  hideZendeskMessaging,
  loginWithZendeskMessaging,
  showZendeskMessaging,
} from 'modules/common/lib/zendesk/zendeskMessagingWidgetUtils'
import Script from 'next/script'
import { useCallback, useEffect } from 'react'

export const ZendeskMessagingScript = () => {
  const { data: user } = useAuthenticatedUserQuery()
  const { shouldDisplayZendeskMessagingWidget, zendeskScriptKey } =
    useCountryConfig()

  const { mutate: postGenerateVendorToken } =
    usePostGenerateVendorTokenMutation({
      onSuccess: (response) => {
        loginWithZendeskMessaging(response.data.token)
      },
      onSettled: () => {
        showZendeskMessaging()
      },
    })

  const onLoad = useCallback(() => {
    if (user?.corporateId && shouldDisplayZendeskMessagingWidget) {
      postGenerateVendorToken({ vendor: EnumTokenVendors.ZENDESK })
    } else {
      hideZendeskMessaging()
    }
  }, [
    postGenerateVendorToken,
    shouldDisplayZendeskMessagingWidget,
    user?.corporateId,
  ])

  useEffect(() => {
    onLoad()
    // We need onLoad to be ran whenever corporateId changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.corporateId])

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        onLoad()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [onLoad])

  if (!shouldDisplayZendeskMessagingWidget) {
    return null
  }

  return (
    <div>
      <Script
        id="ze-snippet"
        src={`https://static.zdassets.com/ekr/snippet.js?key=${zendeskScriptKey}`}
        onLoad={onLoad}
      />
    </div>
  )
}
